export enum EScheduleType {
	ASAP = 1,
	NOT_RECURRING = 2,
	RECURRING_BY_INTERVAL = 3,
	RECURRING_BY_DAY = 4,
	RECURRING_BY_WEEK = 5,
	RECURRING_BY_DATE = 6,
	RECURRING_BY_LAST_DAY = 7,
	RECURRING_BY_DAY_OF_WEEK = 8,
}
